import { ExotelSipConfig } from './exotel-sip.model';

/** Shared Exotel SIP settings. Per-coach username and secret come from cube details. */
export const exotelSipConfig: ExotelSipConfig = {
  sipdomain: 'pbhealth2m.voip.exotel.com',
  domain: 'voip.in1.exotel.com',
  port: '443',
  security: 'wss',
  endpoint: 'wss',
  callerId: '09240920016',
  integrationId: 'bcbf8f3b-8b98-4e1b-925e-228bc6cd2207',
  integrationSecret: 'fa5f4d8f-a5ac-419a-b9a9-39288e0f8f8a',
  accessToken: '',
  customerId: 'bcbf8f3b-8b98-4e1b-925e-228bc6cd2207',
  appId: '57bd14a3-af98-43e2-9ee5-b52d61abe1a3',
  appSecret: '45295cf9-3b72-4100-a044-5ec1379c0a41',
};
